import React, { useEffect, useState } from "react";
import { adminApi } from "../adminApi";

const statCard = {
  background: "white", borderRadius: 10, padding: "16px 18px",
  border: "1px solid #E5E7EB", boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
};

export default function ExpertAdminOverview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminApi.expertDashboard().then((res) => { if (res.ok) setData(res.data); });
  }, []);

  if (!data) return <div style={{ fontSize: 13, color: "#6B7280" }}>Loading…</div>;
  if (data.migration_required) {
    return (
      <div data-testid="expert-admin-migration-warning" style={{ ...statCard, color: "#B45309" }}>
        C-ORE Expert tables aren't migrated yet — run backend/migrations/2026-08_core_expert.sql in Supabase.
      </div>
    );
  }

  const cards = [
    { id: "new", label: "New Requests", value: data.new_requests, tone: "#1D4ED8" },
    { id: "review", label: "Under Review", value: data.under_review, tone: "#B45309" },
    { id: "active", label: "Active Engagements", value: data.active_engagements, tone: "#047857" },
    { id: "followups", label: "Follow-ups Due", value: data.follow_ups_due, tone: "#DC2626" },
    { id: "completed", label: "Completed", value: data.completed_engagements, tone: "#0F1B2D" },
  ];

  return (
    <div data-testid="expert-admin-dashboard">
      <div className="grid grid-cols-2 desktop:grid-cols-5" style={{ gap: 14 }}>
        {cards.map((c) => (
          <div key={c.id} data-testid={`expert-stat-${c.id}`} style={statCard}>
            <div style={{ fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.5 }}>{c.label}</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: c.tone, marginTop: 4 }}>{c.value ?? 0}</div>
          </div>
        ))}
      </div>
      {data.by_category && Object.keys(data.by_category).length > 0 && (
        <div style={{ ...statCard, marginTop: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#0F1B2D", marginBottom: 8 }}>Requests by category</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {Object.entries(data.by_category).map(([cat, count]) => (
              <div key={cat} style={{ fontSize: 12, color: "#374151", background: "#F3F6FB", borderRadius: 6, padding: "4px 10px" }}>
                {cat}: <b>{count}</b>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
